import 'app/agriculture/routes/Devices/DeviceDetails/components/display/trailcam/TrailCamHistoryRowDisplay.scss';
import { TextWithIcon } from 'app/agriculture/components/TextWithIcon/TextWithIcon';
import { getTimestampDateFormat } from 'app/agriculture/components/Timestamp/timestampUtils';
import { format as formatDate } from 'date-fns';
import { HistoryIcon } from 'app/agriculture/icons';
import { ImageSnapshot } from 'app/agriculture/queries/devices/types/ImageSnapshot';

export function TrailCamHistoryRowDisplay({ timestamp, imageFilename }: ImageSnapshot) {
    const dateFormat = getTimestampDateFormat(timestamp);
    const imagePath = `${window.origin}/${imageFilename}`;
    return (
        <div className="TrailCamHistoryRowDisplay">
            <div className={'TrailCamHistoryRowDisplay--image'}>
                {!imageFilename ? null : <img src={imagePath} alt="Trail cam image" />}
            </div>
            <div className={'TrailCamHistoryRowDisplay--stats'}>
                <TextWithIcon Icon={HistoryIcon}>{formatDate(timestamp, dateFormat)}</TextWithIcon>
            </div>
        </div>
    );
}
